import { ClientImportationsRepository } from "@domain/repositories/ClientImportationsRepository";
import { HttpClient } from "@data/api/HttpClient";
import { Client } from "@domain/models/Client";

export class HttpClientImportationsRepository implements ClientImportationsRepository {
  private readonly baseUrl = `${process.env.REACT_APP_API_URL}/client_importations`;

  constructor(private readonly httpClient: HttpClient) {}

  async getClientImportations(clientId: Client["id"]) {
    return this.httpClient
      .request({
        method: "GET",
        url: `${this.baseUrl}/${clientId}`,
      })
      .then((response) => {
        return response.data;
      });
  }
}
